import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import { WarningIcon } from '@frontend/pole-ui/lib/components/Icon/svg/WarningIcon'
import classNames from 'classnames'
import { InjectHtml } from '@/components/ui'
import { LandingBlockContainer } from '..'
import { initialCategories } from './constants'
import type { IAffiliationProps } from './interfaces'
import { messages } from './messages'
import './styles.scss'

// TODO: при рефакторинге компонента добавить возможность прокидывать совместно со строкой JSX.Element, выкинуть id переводов
const LandingAffiliation: React.FC<IAffiliationProps> = props => {
  const {
    titleId,
    requirementsTitleId,
    requirementsTitleTag,
    className,
    shouldShowDescription,
    shouldShowRequirement,
    descriptionText,
    requirementsText,
    requirementsTextId = requirementsText,
    requirementsAlertText,
    requirementsAlertTextId = requirementsAlertText,
    lawText,
    blockId,
    categories = initialCategories,
    withWhiteBackground,
    isRequirementsAlertBlockHidden,
    landingBlockDescriptionId,
    landingBlockDescriptionClassName,
    shouldShowRequirementsFullWidth,
    requirementsFullWidthTitleTag,
    requirementsFullWidthTitleId,
    requirementsFullWidthTextId,
    requirementsTextTitleId,
    shouldShowRequirementWithoutText,
    containerClassName,
    titleClassName,
  } = props

  return (
    <LandingBlockContainer
      titleId={!shouldShowDescription ? '' : titleId || messages.title}
      titleClassName="landing-constructor-affiliation__title"
      blockId={blockId}
      className={classNames(className, { background_white: withWhiteBackground })}
      withoutPageWrapper
      descriptionId={landingBlockDescriptionId}
      descriptionClassName={landingBlockDescriptionClassName}
    >
      <div className={classNames('landing-constructor-affiliation-container page-wrapper', containerClassName)}>
        {shouldShowDescription && (
          <>
            <InjectHtml html={descriptionText} className="landing-constructor-affiliation-description space-holder64-from-sm" />
            <div className="landing-constructor-affiliation-categories">
              {categories?.map(({ icon, text }, index) => (
                <div key={`${icon}_${index}`} className="landing-constructor-affiliation-category">
                  <span className="landing-constructor-affiliation-category__icon">
                    <Icon component={icon} />
                  </span>
                  <InjectHtml TagName="span" className="landing-constructor-affiliation-category__text" textId={text} />
                </div>
              ))}
            </div>
          </>
        )}
        {shouldShowRequirement && (
          <>
            <div className="space-holder-top32-sm">
              <InjectHtml
                TagName={requirementsTitleTag || 'h3'}
                textId={requirementsTitleId || messages.requirements.title}
                className={classNames(
                  'landing-constructor-affiliation-requirement-title space-holder32 space-holder16-sm h5-sm',
                  titleClassName,
                )}
              />
              {requirementsTextId && !shouldShowRequirementWithoutText && (
                <>
                  {requirementsTextTitleId && (
                    <InjectHtml
                      textId={requirementsTextTitleId}
                      TagName={requirementsTitleTag || 'h5'}
                      className="space-holder32 space-holder32-sm landing-constructor-affiliation-description"
                    />
                  )}
                  <InjectHtml
                    textId={requirementsTextId}
                    className="space-holder32 space-holder32-sm landing-constructor-affiliation-description"
                  />
                </>
              )}
            </div>
            {!isRequirementsAlertBlockHidden && (
              <div>
                <div
                  className={classNames('landing-constructor-affiliation-alert', {
                    'landing-constructor-affiliation-alert_gray': withWhiteBackground,
                  })}
                >
                  <Icon component={<WarningIcon />} className="landing-constructor-affiliation-alert__icon" />
                  <InjectHtml
                    textId={requirementsAlertTextId}
                    className="landing-constructor-affiliation-alert__text space-holder-left24 space-holder-left0-sm space-holder-top8-sm"
                    TagName="p"
                  />
                </div>
              </div>
            )}
            {lawText && (
              <InjectHtml
                html={lawText}
                className="
                landing-constructor-affiliation__sign
                text_super-small
                color_pale-black
                space-holder-top40-from-sm
                space-holder-top32-sm
              "
              />
            )}
          </>
        )}
      </div>
      {shouldShowRequirementsFullWidth && (
        <div className="space-holder-top32-sm page-wrapper landingAffiliationContainerFullWidth">
          <InjectHtml
            TagName={requirementsFullWidthTitleTag || 'h3'}
            textId={requirementsFullWidthTitleId || messages.requirements.title}
            className="landing-constructor-affiliation-requirement-title space-holder32 space-holder16-sm h5-sm"
          />
          <InjectHtml
            textId={requirementsFullWidthTextId}
            className="space-holder32 space-holder32-sm landing-constructor-affiliation-description"
          />
        </div>
      )}
    </LandingBlockContainer>
  )
}

export default LandingAffiliation
